import { render, staticRenderFns } from "./ExerciseHintsSidebarBox.vue?vue&type=template&id=83827d10&scoped=true&"
import script from "./ExerciseHintsSidebarBox.vue?vue&type=script&lang=js&"
export * from "./ExerciseHintsSidebarBox.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseHintsSidebarBox.vue?vue&type=style&index=0&id=83827d10&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83827d10",
  null
  
)

export default component.exports